export enum QuestionTypes {
    Text="Text",
    FileUpload="FileUpload",
    TextArea="TextArea",
    Entertext = "Entertext",
    DatePicker="DatePicker",
    DOB="DOB",
    PastDatePicker="PastDatePicker",
    FutureDatePicker="FutureDatePicker",
    SSN="SSN",
    PhoneNumber="PhoneNumber",
    YesOrNo="YesOrNo",
    MultiSelectionDropdown="MultiSelectionDropdown",
    MultiSelectionCheckBox="MultiSelectionCheckBox",
    MultiCheckBox="MultiCheckBox",
    MultiSelectionBoxSelection="MultiSelectionBoxSelection",
    SingleSelectionDropDown="SingleSelectionDropDown",
    SingleSelectionCheckBox="SingleSelectionCheckBox",
    AddressSelectionCheckBox="AddressSelectionCheckBox",
    SingleSelectionBoxSelection="SingleSelectionBoxSelection",
    Email="Email",
    Number="Number",
    Currency="Currency",
    ZipCode="ZipCode",
    TaxId = "TaxId",
    FaxId = "FaxId",
    AlphaNumeric="AlphaNumeric"
      }
    
    